import script from "./ToastApp.vue?vue&type=script&setup=true&lang=js"
export * from "./ToastApp.vue?vue&type=script&setup=true&lang=js"

import "./ToastApp.vue?vue&type=style&index=0&id=4a77fec9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a77fec9"]])

export default __exports__